//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminTransactionController_updateOneById,
  Response$AdminTransactionController_updateOneById$Status$200,
  ResponseContentType$AdminTransactionController_updateOneById,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminTransactionController_updateOneById = () =>
  useApiClientMutation<
    Params$AdminTransactionController_updateOneById,
    Response$AdminTransactionController_updateOneById$Status$200[ResponseContentType$AdminTransactionController_updateOneById]
  >({ method: 'AdminTransactionController_updateOneById' });
